import { render, staticRenderFns } from "./AfiliadosRecebimentos.vue?vue&type=template&id=93816094"
import script from "./AfiliadosRecebimentos.vue?vue&type=script&lang=ts"
export * from "./AfiliadosRecebimentos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports